import React from 'react';

const IndexPage = () => {
  document.title = '';
  let title = '',
  mail = '';
  const host = window.location.host;
  if(host.indexOf('iccrouter') > -1) {
    document.title = process.env.REACT_APP_ICCROUTER;
    title = process.env.REACT_APP_ICCROUTER;
    mail = process.env.REACT_APP_ICCROUTER_MAIL;
  } else {
    document.title = process.env.REACT_APP_SHADOWFOG;
    title = process.env.REACT_APP_SHADOWFOG;
    mail = process.env.REACT_APP_SHADOWFOG_MAIL;
  }
  const nameParam = window.location.search;
  return (
    <div>
      <div id="preloader">
        <div className="loder-box">
          <div className="battery"></div>
        </div>
      </div>

      <header id="navigation" className="navbar-inverse navbar-fixed-top animated-header">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
    						<span className="sr-only">Toggle navigation</span>
    						<span className="icon-bar"></span>
    						<span className="icon-bar"></span>
    						<span className="icon-bar"></span>
            </button>
            <h1 className="navbar-brand">
    					<a href="#body">{title}</a>
    				</h1>
          </div>

          <nav className="collapse navbar-collapse navbar-right" role="navigation">
            <ul id="nav" className="nav navbar-nav">
              <li><a href="#body">Home</a></li>
              <li><a href="#service">Service</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#testimonials">Testimonial</a></li>
              <li><a href="#price">Price</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#links">Links</a></li>
            </ul>
            <ul className="nav navbar-nav">
              <li><a id="signup-link" href={"/signup"+nameParam}><b>Sign up</b></a></li>
              <li><a id="signin-link" href={"/login"+nameParam}><b>Sign in</b></a></li>
            </ul>
          </nav>
        </div>
      </header>

      <main className="site-content" role="main">
        <section id="home-slider">
          <div id="slider" className="sl-slider-wrapper">
            <div className="sl-slider">
              <div className="sl-slide" data-orientation="horizontal" data-slice1-rotation="-25" data-slice2-rotation="-25" data-slice1-scale="2" data-slice2-scale="2">
                <div className="bg-img bg-img-1"></div>
                <div className="slide-caption">
                  <div className="caption-content">
                    <h2 className="animated fadeInDown">Shadow in the Fog</h2>
                    <span className="animated fadeInDown">Closer to You & Knows You Better</span>
                    <a href={"/login"+nameParam} className="btn btn-blue btn-effect">Get it NOW!</a>
                  </div>
                </div>
              </div>

              <div className="sl-slide" data-orientation="vertical" data-slice1-rotation="10" data-slice2-rotation="-15" data-slice1-scale="1.5" data-slice2-scale="1.5">
                <div className="bg-img bg-img-2"></div>
                <div className="slide-caption">
                  <div className="caption-content">
                    <h2>A Spiritual Path to Shangri-La</h2>
                    <span>Quality with Resonable Price</span>
                    <a href={"/login"+nameParam} className="btn btn-blue btn-effect">Get it NOW!</a>
                  </div>
                </div>
              </div>

              <div className="sl-slide" data-orientation="horizontal" data-slice1-rotation="3" data-slice2-rotation="3" data-slice1-scale="2" data-slice2-scale="1">
                <div className="bg-img bg-img-3"></div>
                <div className="slide-caption">
                  <div className="caption-content">
                    <h2>Things are There, But Invisible</h2>
                    <span>Smooth & Safe Experience</span>
                    <a href={"/login"+nameParam} className="btn btn-blue btn-effect">Get it NOW!</a>
                  </div>
                </div>
              </div>
            </div>

            <nav id="nav-arrows" className="nav-arrows hidden-xs hidden-sm visible-md visible-lg">
              <a href="javascript:;" className="sl-prev">
                <i className="fa fa-angle-left fa-3x"></i>
              </a>
              <a href="javascript:;" className="sl-next">
                <i className="fa fa-angle-right fa-3x"></i>
              </a>
            </nav>
            <nav id="nav-dots" className="nav-dots visible-xs visible-sm hidden-md hidden-lg">
              <span className="nav-dot-current"></span>
              <span></span>
              <span></span>
            </nav>
          </div>
        </section>

        <section id="about">
          <div className="container">
            <div className="row">
              <div className="col-md-4 wow animated fadeInLeft">
                <div className="recent-works">
                  <h3>Recent News</h3>
                  <div id="works">
                    <div className="work-item">
                      <p>Try <b><a style={{color:'#FFFFFF'}} href="https://github.com/ShadowFog/shadowfog-windows/releases/latest" target="_blank" rel="noopener noreferrer">ShadowFog Windows Version 0.4.2</a></b> Now! <br /><br /> Client works on Windows 7/8/8.1/10,<br />MacOS/Android/IOS/ can
                        use our service with <b>ShadowFog</b>.<br/><br/> Thanks for your attention!</p>
                    </div>
                    <div className="work-item">
                      <p> <br /><br /> </p>
                    </div>
                    <div className="work-item">
                      <p> <br /><br /> </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-7 col-md-offset-1 wow animated fadeInRight">
                <div className="welcome-block">
                  <h3>Welcome to {title}</h3>
                  <div className="message-body">
                    <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/member-1.jpg'} className="pull-left" alt="member" />
                    <p>{title} is a product containing secure communication and power efficient hardware. The most highlighted feature is the distributed server network behaving like fog covering around customers. We sell both communication services and mini
                      servers in different portfolios.</p>
                  </div>
                  <a href="#" className="btn btn-border btn-effect pull-right">Read More</a>
                </div>
              </div>
            </div>
          </div>
        </section>



        <section id="service">
          <div className="container">
            <div className="row">

              <div className="sec-title text-center">
                <h2 style={{textTransform: 'none'}}>Who else is using {title}?</h2>
                <p className="wow animated bounceInRight">
                  <a href="http://navy.81.cn/" target="_blank" rel="noopener noreferrer">
    						        <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/cn_navy.gif'} style={{height: '50px', margin:'5px'}} title="中国海军" />
    						    </a>
                  <a href="http://www.tsinghua.edu.cn/" target="_blank" rel="noopener noreferrer">
    						        <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/thu.png'} style={{height: '50px', margin:'5px'}} title="清华大学" />
    						    </a>
                  <a href="http://www.belleintl.com/" target="_blank" rel="noopener noreferrer">
    						        <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/baili.png'} style={{height: '50px', width: '150px', margin: '5px'}} title="百丽国际" />
    						    </a>
                  <a href="http://www.dentons.com/" target="_blank" rel="noopener noreferrer">
    						        <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/dentons.jpg'} style={{height: '50px', width: '150px', margin:'5px'}} title="大成(Dentons)律师事务所" />
    						    </a>
                  <a href="http://fyt.hkust.edu.cn/" target="_blank" rel="noopener noreferrer">
    						        <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/fyt.png'} style={{height: '50px', margin:'5px'}} title="香港科技大学霍英研究院" />
    						    </a>
                </p>
              </div>

              <div className="sec-title text-center">
                <h2 className="wow animated bounceInLeft">Service</h2>
                <p className="wow animated bounceInRight">The key features of our Job</p>
              </div>

              <div className="col-md-3 col-sm-6 col-xs-12 text-center wow animated zoomIn">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fa fa-home fa-3x"></i>
                  </div>
                  <h3>Home Clients</h3>
                  <p>Enjoy our secure communication channels to surf scientifically </p>
                </div>
              </div>

              <div className="col-md-3 col-sm-6 col-xs-12 text-center wow animated zoomIn" data-wow-delay="0.3s">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fa fa-server fa-3x"></i>
                  </div>
                  <h3>Mini Servers</h3>
                  <p>The versatile server can play an "All-in-One" role in your home </p>
                </div>
              </div>

              <div className="col-md-3 col-sm-6 col-xs-12 text-center wow animated zoomIn" data-wow-delay="0.6s">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fa fa-btc fa-3x"></i>
                  </div>
                  <h3>Sharing Eco</h3>
                  <p>The hosts will get rewarded by sharing their idle resources </p>
                </div>
              </div>

              <div className="col-md-3 col-sm-6 col-xs-12 text-center wow animated zoomIn" data-wow-delay="0.9s">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fa fa-cog fa-3x"></i>
                  </div>

                  <h3>Tech Support</h3>
                  <p>We open-source our software and offer fast responses to problems </p>
                </div>
              </div>

            </div>
          </div>
        </section>



        <section id="portfolio">
          <div className="container">
            <div className="row">

              <div className="sec-title text-center wow animated fadeInDown">
                <h2>Featured Products</h2>
                <p>The ShadowFog<sup>&reg;</sup> Powered Gateways not only provide client services, but also act as super servers in various forms</p>
              </div>


              <ul className="project-wrapper wow animated fadeInUp">
                <li className="portfolio-item">
                  <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/portfolio/item.jpg'} className="img-responsive" alt="Highest performance among all fog gateways, multi-functional at home." />
                  <figcaption className="mask">
                    <h3>High-end Mini PC</h3>
                    <p>Highest performance among all fog gateways, multi-functional at home. </p>
                  </figcaption>
                  <ul className="external">
                    <li><a className="fancybox" title="High-end Mini PC" data-fancybox-group="works" href="img/portfolio/item_full.jpg"><i className="fa fa-search"></i></a></li>
                    <li><a href="#"><i className="fa fa-link"></i></a></li>
                  </ul>
                </li>

                <li className="portfolio-item">
                  <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/portfolio/item2.jpg'} className="img-responsive" alt="Sold at cost. We don't earn any profit on this recommended hardware." />
                  <figcaption className="mask">
                    <h3>Ordinary Mini PC</h3>
                    <p>Sold at cost. We don't earn any profit on this recommended hardware. </p>
                  </figcaption>
                  <ul className="external">
                    <li><a className="fancybox" title="Ordinary Mini PC" href="img/portfolio/item2_full.jpg" data-fancybox-group="works"><i className="fa fa-search"></i></a></li>
                    <li><a href=""><i className="fa fa-link"></i></a></li>
                  </ul>
                </li>

                <li className="portfolio-item">
                  <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/portfolio/item3.jpg'} className="img-responsive" alt="FREE for Gold Package. Quiet, cool with low power consumption." />
                  <figcaption className="mask">
                    <h3>Low-cost Mini PC</h3>
                    <p><b>FREE</b> for <a href="#price"><b>Gold Package</b></a>. Quiet, cool with low power consumption.</p>
                  </figcaption>
                  <ul className="external">
                    <li><a className="fancybox" title="Low-cost Mini PC" data-fancybox-group="works" href="img/portfolio/item3_full.jpg"><i className="fa fa-search"></i></a></li>
                    <li><a href=""><i className="fa fa-link"></i></a></li>
                  </ul>
                </li>

                <li className="portfolio-item">
                  <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/portfolio/item4.jpg'} className="img-responsive" alt="Android OS based TV Boxes can be easily set working as gateways." />
                  <figcaption className="mask">
                    <h3>TV Box</h3>
                    <p>Android OS based TV Boxes can be easily set working as gateways. </p>
                  </figcaption>
                  <ul className="external">
                    <li><a className="fancybox" title="TV Box" data-fancybox-group="works" href="img/portfolio/item4_full.jpg"><i className="fa fa-search"></i></a></li>
                    <li><a href=""><i className="fa fa-link"></i></a></li>
                  </ul>
                </li>

                <li className="portfolio-item">
                  <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/portfolio/item5.jpg'} className="img-responsive" alt="Equipped with large storage. Suitable for NAS and CDN cache. " />
                  <figcaption className="mask">
                    <h3>HDD Dock</h3>
                    <p>Equipped with large storage. Suitable for NAS and CDN cache. </p>
                  </figcaption>
                  <ul className="external">
                    <li><a className="fancybox" title="HDD Dock" data-fancybox-group="works" href="img/portfolio/item5_full.jpg"><i className="fa fa-search"></i></a></li>
                    <li><a href=""><i className="fa fa-link"></i></a></li>
                  </ul>
                </li>

                <li className="portfolio-item">
                  <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/portfolio/item6.jpg'} className="img-responsive" alt="Routers with OpenWRT or DDWRT OS are ready to be ported with our services. " />
                  <figcaption className="mask">
                    <h3>Smart Router</h3>
                    <p>Routers with OpenWRT/DDWRT are ready to be ported with our services. </p>
                  </figcaption>
                  <ul className="external">
                    <li><a className="fancybox" title="Smart Router" data-fancybox-group="works" href="img/portfolio/item6_full.jpg"><i className="fa fa-search"></i></a></li>
                    <li><a href=""><i className="fa fa-link"></i></a></li>
                  </ul>
                </li>
              </ul>

            </div>
          </div>
        </section>

        <section id="testimonials" className="parallax">
          <div className="overlay">
            <div className="container">
              <div className="row">

                <div className="sec-title text-center white wow animated fadeInDown">
                  <h2>What people say</h2>
                </div>

                <div id="testimonial" className=" wow animated fadeInUp">
                  <div className="testimonial-item text-center">
                    <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/member-2.jpg'} alt="Our Clients" />
                    <div className="clearfix">
                      <span>Sergey Kolesov</span>
                      <p>ShadowFog gives me the freedom on cooperating with foreign companies, the concurrent multi-channel video conferences through ShadowFog are so smooth that I just take it as having a face to face talk with my customers. Many thanks to
                        ShadowFog, who makes my daily work so easy.</p>
                    </div>
                  </div>
                  <div className="testimonial-item text-center">
                    <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/member-3.jpg'} alt="Our Clients" />
                    <div className="clearfix">
                      <span>Rachel Shelley</span>
                      <p>ShadowFog helps me place orders on Amazon, Ebay, Lotte, GNC, Bestbuy, The Fifth Avenue, Sephora and etc.. It also enables me chatting with my friends all over the world through Gmail or Instagram. Every night I cann't sleep without Netflix's
                        series thanks to ShadowFog. </p>
                    </div>
                  </div>
                  <div className="testimonial-item text-center">
                    <img alt="" src={process.env.PUBLIC_URL + '/indexPage/img/member-4.jpg'} alt="Our Clients" />
                    <div className="clearfix">
                      <span>Ming Lee</span>
                      <p>I usually get into ScienceDirect and other resources for academic reasearch. When I'm out of university, I need ShadowFog to access these websites. It saves me so much time, and I want to be a ShadowFog's lifetime VIP member.</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>



        <section id="price">
          <div className="container">
            <div className="row">

              <div className="sec-title text-center wow animated fadeInDown">
                <h2>Price</h2>
                <p>Our price for your choice</p>
              </div>

              <div className="col-md-4 wow animated fadeInUp">
                <div className="price-table text-center">
                  <span>Copper</span>
                  <div className="value">
                    <span>$</span>
                    <span>1,99</span><br />
                    <span>1 month</span>
                  </div>
                  <ul>
                    <li>Free Trial</li>
                    <li>Traffic Limit</li>
                    <li>Content Limit</li>
                    <li>No Bonus Points</li>
                    <li><a href="#">sign up</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 wow animated fadeInUp" data-wow-delay="0.4s">
                <div className="price-table featured text-center">
                  <span>Silver</span>
                  <div className="value">
                    <span>$</span>
                    <span>19,99</span><br />
                    <span>1 year</span>
                  </div>
                  <ul>
                    <li>Free Trial</li>
                    <li>Conditional Traffic Limit</li>
                    <li>Partial Content Limit</li>
                    <li>No Bonus Points</li>
                    <li><a href="#">sign up</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 wow animated fadeInUp" data-wow-delay="0.8s">
                <div className="price-table text-center">
                  <span>Gold</span>
                  <div className="value">
                    <span>$</span>
                    <span>99,99</span><br />
                    <span>3 years</span>
                  </div>
                  <ul>
                    <li><a href="#portfolio"><b>FREE<sup>*</sup></b> ShadowFog<sup>&reg;</sup> Gateway</a></li>
                    <li>No Traffic Limit</li>
                    <li>No Content Limit</li>
                    <li>Bonus Points</li>
                    <li><a href="#">sign up</a></li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </section>



        <section id="social" className="parallax">
          <div className="overlay">
            <div className="container">
              <div className="row">

                <div className="sec-title text-center white wow animated fadeInDown">
                  <h2>Follow Us</h2>
                  <p>If you are interested in our products, services & technology, please follow us on</p>
                </div>

                <ul className="social-button">
                  <li className="wow animated zoomIn"><a href="#"><i className="fa fa-thumbs-up fa-2x"></i></a></li>
                  <li className="wow animated zoomIn" data-wow-delay="0.3s"><a href="#"><i className="fa fa-twitter fa-2x"></i></a></li>
                  <li className="wow animated zoomIn" data-wow-delay="0.6s"><a href="#"><i className="fa fa-dribbble fa-2x"></i></a></li>
                </ul>

              </div>
            </div>
          </div>
        </section>



        <section id="contact">
          <div className="container">
            <div className="row">

              <div className="sec-title text-center wow animated fadeInDown">
                <h2>Contact</h2>
                <p>Leave a Message</p>
              </div>


              <div className="col-md-7 contact-form wow animated fadeInLeft">
                <form action="#" method="post">
                  <div className="input-field">
                    <input type="text" name="name" className="form-control" placeholder="Your Name..." />
                  </div>
                  <div className="input-field">
                    <input type="email" name="email" className="form-control" placeholder="Your Email..." />
                  </div>
                  <div className="input-field">
                    <input type="text" name="subject" className="form-control" placeholder="Subject..." />
                  </div>
                  <div className="input-field">
                    <textarea name="message" className="form-control" placeholder="Messages..."></textarea>
                  </div>
                  <button type="submit" id="submit" className="btn btn-blue btn-effect">Send</button>
                </form>
              </div>

              <div className="col-md-5 wow animated fadeInRight">
                <address className="contact-details">
    								<h3>Contact Us</h3>
    								<p><i className="fa fa-pencil"></i>Semenovskaya nab.<span>PO Box 105094</span> <span> 2/1, p. 1, </span><span> Moscow, Russia</span></p><br />
    								<p><i className="fa fa-phone"></i>Phone: +7 495 778-53-70 </p>
    								<p><i className="fa fa-envelope"></i>{mail}</p>
    							</address>
              </div>

            </div>
          </div>
        </section>

      </main>

      <footer id="footer">
        <div className="container" id="links">

          <div className="col-md-4">
            <div className="row text-center">
              <div className="footer-content">
                <div className="wow animated fadeInDown">
                  <h2 style={{color:'#FFFFFF'}}>Links</h2>
                  <ul style={{textAlign:'left'}}>
                    <li><a href="http://befo.io/" target="_blank" rel="noopener noreferrer">befo</a></li>

                  </ul>
                </div>


              </div>
            </div>
          </div>


          <div className="col-md-4">
          </div>


          <div className="col-md-4">
            <div className="row text-center">
              <div className="footer-content">
                <div className="wow animated fadeInDown">
                  <p>newsletter signup</p>
                  <p>Get Cool Stuff! We hate spam!</p>
                </div>
                <form action="#" method="post" className="subscribe-form wow animated fadeInUp">
                  <div className="input-field">
                    <input type="email" className="subscribe form-control" placeholder="Enter Your Email..." />
                    <button type="submit" className="submit-icon">
    											<i className="fa fa-paper-plane fa-lg"></i>
    										</button>
                  </div>
                </form>
                <div className="footer-social">
                  <ul>
                    <li className="wow animated zoomIn"><a href="#"><i className="fa fa-thumbs-up fa-3x"></i></a></li>
                    <li className="wow animated zoomIn" data-wow-delay="0.3s"><a href="#"><i className="fa fa-twitter fa-3x"></i></a></li>
                    <li className="wow animated zoomIn" data-wow-delay="0.6s"><a href="#"><i className="fa fa-skype fa-3x"></i></a></li>
                    <li className="wow animated zoomIn" data-wow-delay="0.9s"><a href="#"><i className="fa fa-dribbble fa-3x"></i></a></li>
                    <li className="wow animated zoomIn" data-wow-delay="1.2s"><a href="#"><i className="fa fa-youtube fa-3x"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>


        </div>
      </footer>
    </div>
  );
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/IndexPage.js